export default __webpack_public_path__ + "static/nft5-22723dbe5f1754bfa9646a0f04876d42.png";